import axios from 'axios';
import CryptoJS from 'crypto-js';

import { API_URL, API_KEY, EMAIL_KEY } from './config/settings';
import { GlobalConstants } from './GlobalConstants';
import { toast } from 'react-toastify';
import { ReduxUpdater } from './redux/ReduxUpdater';

// export interface IBankingData {
//     booking_id: string;
//     booking_date: string;
//     partners_name: string;
//     amount: number;
//     currency: string;
//     original_amount: number;
//     original_Currency: string;
//     transaction_date: string;
//     transaction_time: string
// }

// --- Types ---
export type ReceiptStatusENUM = 'approved' | 'confirmed' | 'denied' | 'locked' | 'pending' | 'reimbursed' | 'submitted'  | 'trashed' | null;
export type ReceiptTypeENUM = 'petty_cash' | 'reimbursement' | null;

export interface IBankTransactionsResponseData {
    items: IBankTransactionData[];
    total: number;
    page: number;
    per_page: number;
    pages: number;
    has_next: boolean;
    has_prev: boolean;
}

export interface IPettyCashIndexData {
    id: string;
    date: string;
    type: string;
}

export interface IPettyCashResponseData {
    items: IPettyCashIndexData[];
    objects: { [id: string]: IBankTransactionData | IReceiptData };
    total: number;
    page: number;
    per_page: number;
    pages: number;
    has_next: boolean;
    has_prev: boolean;
}

export interface IBankTransactionData {
    [key: string]: unknown;
    id: number;
    reference_number: string;
    refund_reference_id: string;
    booking_date: string;
    partner_name: string;
    partner_iban: string;
    partner_bic: string;
    partner_amount: string;
    partner_currency: string;
    sender_iban: string;
    sender_amount: string;
    sender_currency: string;
    extracted_type: string;
    extracted_amount: string;
    extracted_currency: string;
    extracted_exchange_rate: string;
    extracted_fee: string;
    extracted_card_name: string;
    extracted_date: string;
    extracted_time: string;
    extracted_location: string;
    extracted_entgelt: string;
    extracted_spesen: string;
    extracted_kurs: string;
    extracted_vom: string;
    reference_text: string;
    matched: boolean;
    matched_receipt: IReceiptData;
    created_at: string;
    updated_at: string;
}

export interface ICurrencyData {
    currency_code: string;
    currency_iso_code: number;
    digits: number;
    currency_symbol: string;
    currency_name: string;
    countries_used: string;
    notes: string;
    active: boolean;
    id: number;
    created_at: string;
    updated_at: null;
}

export interface ICrewData {
    [key: string]: unknown;
    id: number;
    phone_number: string;
    debit_card_number: string | null;
    card_name: string | null;
    first_name: string;
    last_name: string;
    position: string;
    user_role: string;
    person_group: string;
    email: string;
    bic: string;
    routing_number: string;
    city: string;
    country: string;
    // image_url: string; //Removed
    yacht_id: number;
    gsheet_id: string;
    zoho_chart_of_accounts_id: string | null;
    zoho_cash_chart_of_accounts_id: string | null;
    zoho_customer_id: string | null;
    password: string | null;
    initial_petty_cash_balance: { [currency: string]: number } | null;

    reimburse_only: boolean;

    is_onboarded: boolean | null;
    profile_image_bytes: string;
    created_at: string;
    updated_at: string;

    impersonate: ICrewData | null;
}

export interface ICrewResponseData {
    items: ICrewData[];
    total: number;
    page: number;
    per_page: number;
    pages: number;
    has_next: boolean;
    has_prev: boolean;
}

export interface IYachtData {
    [key: string]: unknown;
    id: number;
    name: string;
    flag: string;
    brand: string;
    loa: string;
    type: string;
    gt: string;
    official_number: string;
    callsign: string;
    image_url: string;
    iban: string;
    zohoOrgID: string;
    gsheet_id: string;
    next_receipt: number;
    created_at: string;
    updated_at: string;
}

export interface IYachtCurrenciesData {
    yacht_id: number;
    currencies: string[];
}

export interface IYachtResponseData {
    items: IYachtData[];
    total: number;
    page: number;
    per_page: number;
    pages: number;
    has_next: boolean;
    has_prev: boolean;
}

export interface IMatchData {
    id: string,
    booking_id: string;
    message_id: string;
    linked_status: string;
}

export interface IReceiptData {
    [key: string]: unknown;
    id: number;
    message_id: string;
    user_timestamp: string | null;
    user_phone_number: string;
    transaction_date: string | null;
    transaction_time: string | null;
    vendor_name: string;
    amount: string | null;
    tip_amount: string;
    currency: string | null;
    general_item_description: string;
    pan_number: string | null;
    includes_payment_card_slip: boolean;
    includes_receipt: boolean;
    is_paid_with_cash: boolean;
    is_receipt_pic: boolean;
    supabase_image_link: string;
    user_description: string | null;
    receipt_type: ReceiptTypeENUM;
    requires_payment: boolean;
    reimbursement_status: string | null;
    reimbursement_package_id: number | null;
    reimbursement_chat: string[] | null;
    co_owner_name: string;
    maris_category_id: number | null;
    receipt_status: ReceiptStatusENUM;
    confirmed_user_id: number | null;
    user_id: number;
    matched_bank_transaction_id: number | null;
    matched_fields: string | null;
    match_confidence: number | null;
    created_at: string;
    updated_at: string;
    matched_bank_transaction: IBankTransactionData | null;
    changed_by_user_id: number | null;
}

export interface IReceiptHistoryData {
    [key: string]: unknown;
    id: number;
    receipt_id: number;
    event_type: string;
    changed_by_user_id: number;
    source: string;
    changes: any;
    snapshot_after: any;
    created_at: string;
}

export interface IReceiptsResponseData {
    items: IReceiptData[];
    total: number;
    page: number;
    per_page: number;
    pages: number;
    has_next: boolean;
    has_prev: boolean;
}

export interface IReceiptsHistoryResponseData {
    items: IReceiptHistoryData[];
    total: number;
    page: number;
    per_page: number;
    pages: number;
    has_next: boolean;
    has_prev: boolean;
}

export interface IReimbursementPackageData {
    id: number;
    report_id: string | null;
    package_id: string;
    package_date: string;
    package_status: string;
    report_url: string;
    receipts: IReceiptData[];
    created_at: string;
    updated_at: string;
}

export interface IReimbursementPackagesResponseData {
    items: IReimbursementPackageData[];
    total: number;
    page: number;
    per_page: number;
    pages: number;
    has_next: boolean;
    has_prev: boolean;
}

export interface IReimbursementUsersSummaryData {
    user_id: number;
    first_name: string;
    last_name: string;
    position: string;
    pending_receipts_count: number;
    reimbursement_packages_count: number;
}

export interface IReimbursementUsersSummaryResponseData {
  yacht_id: number;
  items: IReimbursementUsersSummaryData[];
  total_users: 0;
}

export interface IUsersPettyCashResponseData {
    iban: string;
    card_name: string;
    user_phone: string;
    user_id: number;
    first_name: string;
    last_name: string;
    atm_total: number;
    unmatched_receipts_total: number;
    unmatched_receipts_count: number;
    initial_balance: number,
    petty_cash: number;
    currency: string;
    opening_balance_this_month: number,
    cash_receipts_this_month: number,
    atm_withdrawals_this_month:number,
    atm_withdrawals_count_this_month: number,
    cash_receipts_count_this_month: number,
    cash_receipts_amount_before_month: number,
    atm_withdrawals_amount_before_month: number,
}

export interface IAccountingCategoriesData {
    id: number,
    name: string,
    sort_order: number,
    created_at: string,
    updated_at: string | null
}

export interface IGenerateReportData {
  package_id: number;
  report_url: string;
  receipts_included: number;
  images_included: number;
  pdfs_included: number;
  attachments_failed: number;
}

export interface IAccountingCategories {
    items: IAccountingCategoriesData[],
    total: 0,
    page: 0,
    pages: 0,
    per_page: 0,
    has_next: false,
    has_prev: false,
}

export interface ISendToZohoError {
    receipt_id: number;
    error: string;
}

export interface ISendToZohoResponse {
  success: boolean,
  message: string,
  total_receipts: number,
  successful: number,
  failed: number,
  errors: ISendToZohoError[],
  successful_receipts: []
}

export const emptyResponseData = {
    items: [],
    total: 0,
    page: 0,
    pages: 0,
    per_page: 0,
    has_next: false,
    has_prev: false,
};

export const emptyPettyCashResponseData = {
    items: [],
    objects: {},
    total: 0,
    page: 0,
    pages: 0,
    per_page: 0,
    has_next: false,
    has_prev: false,
};

export const emptyUsersPettyCashResponseData: IUsersPettyCashResponseData = {
    iban: '',
    card_name: '',
    user_phone: '',
    user_id: -1,
    first_name: 'Empty',
    last_name: 'User',
    atm_total: 0,
    unmatched_receipts_total: 0,
    unmatched_receipts_count: 0,
    initial_balance: 0,
    petty_cash: 0,
    currency: 'EUR',
    opening_balance_this_month: 0,
    cash_receipts_this_month: 0,
    atm_withdrawals_this_month: 0,
    atm_withdrawals_count_this_month: 0,
    cash_receipts_count_this_month: 0,
    cash_receipts_amount_before_month: 0,
    atm_withdrawals_amount_before_month: 0,
};

export interface IPostResponse {
  data: any | null,
  status: number,
}
export interface IUploadFileToSupabaseResponse {
    success: boolean,
    supabase_url: string,
    file_path: string,
    file_number: string,
}

export interface IUploadReceiptResponse {
    success: boolean,
    message: string,
    receipt_id: number,
    duplicate_of_receipt_id: number,
    error: string,
}

export interface IBrevoEmail {
  topic: string,
  message: string,
}

export class ApiCalls {
    private static isTesting = process.env.REACT_APP_UX_TESTING === 'true';
    private static pullRealIfMissing = process.env.REACT_APP_GET_REAL_IF_MISSING === 'true';
    private static testBackendURL = process.env.REACT_APP_BACKEND_URL ?? 'http://localhost:3002/testData';
    private static registeredErrors: string[] = [];
    private static readonly _LOCAL_STORAGE_IMAGES = 'MarisAPP::Images';

    // private static _readJsonFile(filePath: string): any | null {
    //     try {
    //         const data = fs.readFileSync(filePath, 'utf8');
    //         return JSON.parse(data);
    //         // const data = JSON.parse(jsonString);
    //         // console.log(data); // 'data' is a JavaScript object
    //     } catch (err) {
    //         console.error('Error reading file:', err);
    //     }
    //     return null;
    // }

    private static _emailError = async (func: string, input: string, error: string) => {
        // if (!EMAIL_KEY) {
        //     console.error('Missing Email API KEY:', func, error);
        //     return;
        // }

        // const errorSHA256 = CryptoJS.SHA256(error).toString(CryptoJS.enc.Hex);
        // if (this.registeredErrors.includes(errorSHA256)) {
        //     // Only report it once!!!
        //     return;
        // }

        // this.registeredErrors.push(errorSHA256);

        // const url = 'https://n8n.my-maris.app/webhook/a5fa7aa0-baf2-4ce2-ae13-f88a6299222a';

        // const settings = {
        //     method: 'POST',
        //     headers: {
        //         'Accept': 'application/json',
        //         'Content-Type': 'application/json',
        //         'api-key': EMAIL_KEY
        //     }
        // };

        // const emailData = {
        //     topic: `My Maris ${func} ERROR${this.isTesting ? ' (TESTING)' : ''}!`,
        //     message: `Maris request error:\n\n${input}\n\n${error}`
        // }

        // const d: IPostResponse = {
        //     data: null,
        //     status: 500
        // }
        // try {
        //     const { data, status } = await axios.post(url, emailData, settings);
        //     d.data = data;
        //     d.status = status;
        //     if (status < 200 || status >= 300) {
        //         console.error('_emailError', url, JSON.stringify(data));
        //     }
        // }
        // catch (error) {
        //     if (axios.isAxiosError(error)) {
        //         console.error(error);
        //     } else {
        //         console.error(error);
        //     }
        //     // this._emailError(func, {
        //     //     topic: `My Maris ${func} ERROR${this.isTesting ? ' (TESTING)' : ''}!`,
        //     //     message: JSON.stringify(error)
        //     // });
        // }
        // return d;
    }

    private static _fetchStatus = async (url: string, redirect = true): Promise<number | Error> => {
        if (redirect && this.isTesting) {
            throw new Error('_fetchStatus not implemented!!!');
        }

        const settings = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${API_KEY}`
            }
        };
        try {
            const { status } = await axios.get(url, settings);
            return status;
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                console.error(error);
            } else {
                console.error(error);
            }
            this._emailError('_fetchStatus', url, JSON.stringify(error));
        }
        return -1;
    };

    private static _fetchJsonData = async (url: string, redirect = true, originalUrl?: string): Promise<any | null> => {
        if (redirect && this.isTesting) {
            const urlObject = new URL(url);
            var suffix = '';
            if (urlObject.search) {
                // suffix = '-' + CryptoJS.SHA256(urlObject.search).toString(CryptoJS.enc.Hex);
                suffix = '/' + urlObject.search.replaceAll('?', '').replaceAll('=', '-').replaceAll('&', '/');
            }
            console.log('SUFIX:', suffix);
            const data = await this._fetchJsonData(`${this.testBackendURL}/${urlObject.pathname.replace(/^\/+|\/+$/g, '')}${suffix}.json`, false, url);
            if (!data) {
                if (this.pullRealIfMissing) {
                    const data = await this._fetchJsonData(url, false);
                    console.log(`${this.testBackendURL}/${urlObject.pathname.replace(/^\/+|\/+$/g, '')}${suffix}.json >> `, JSON.stringify(data));
                    return data;
                }
                return null;
            }
            return data;
        }

        const settings = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${API_KEY}`
            }
        };
        let d: any | null = null;
        try {
            const { data, status } = await axios.get(url, settings);
            d = data;
            d.status = status;
            if (status < 200 || status >= 300) {
                this._emailError('_fetchJsonData', url, JSON.stringify(data));
            }
        }
        catch (error) {
            if (originalUrl) {
                const data = await this._fetchJsonData(originalUrl, false);
                console.log(`${url} >> `, JSON.stringify(data));
                return data;
            }
            if (axios.isAxiosError(error)) {
                console.error(error);
            } else {
                console.error(error);
            }
            this._emailError('_fetchJsonData', url, JSON.stringify(error));
            d = null;
        }
        return d;
    };

    private static _postJsonData = async (url: string, inputData: any, extraSettings = {}): Promise<IPostResponse> => {
        if (this.isTesting) {
            const urlObject = new URL(url);
            var suffix = '';
            if (urlObject.search) {
                // suffix = '-' + CryptoJS.SHA256(urlObject.search).toString(CryptoJS.enc.Hex);
                suffix = '/' + urlObject.search.replaceAll('?', '').replaceAll('=', '-').replaceAll('&', '/');
            }
            console.log('SUFIX:', suffix);
            const data = await this._fetchJsonData(`${this.testBackendURL}/POST/${urlObject.pathname.replace(/^\/+|\/+$/g, '')}${suffix}.json`, false);
            console.log('_postJsonData:', data);
            if (data === null) {
                return inputData;
            }
            return data;
        }

        const settings = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${API_KEY}`
            },
            ...extraSettings
        };
        const d: IPostResponse = {
            data: null,
            status: 500
        }
        try {
            const { data, status } = await axios.post(url, inputData, settings);
            d.data = data;
            d.status = status;
            if (status < 200 || status >= 300) {
                this._emailError('_postJsonData', url, JSON.stringify(data));
            }
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                console.error(error);
            } else {
                console.error(error);
            }
            this._emailError('_postJsonData', url, JSON.stringify(error));
        }
        return d;
    };

    private static _postFormData = async (url: string, inputData: any): Promise<any | null> => {
        if (this.isTesting) {
            throw new Error('_postFormData not implemented!!!');
        }

        const settings = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${API_KEY}`
            }
        };
        try {
            const { data, status } = await axios.post(url, inputData, settings);
            if (status < 200 || status >= 300) {
                this._emailError('_postFormData', url, JSON.stringify({
                    input: inputData,
                    response: data
                }));
            }
            return data;
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                console.error(error);
            } else {
                console.error(error);
            }
            this._emailError('_postFormData', url, JSON.stringify(error));
        }
        return null;
    };

    private static _putJsonData = async (url: string, data: any): Promise<boolean> => {
        if (this.isTesting) {
            throw new Error('_putJsonData not implemented!!!');
        }

        const settings = {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${API_KEY}`
            }
        };
        try {
            const { status } = await axios.put(url, data, settings);
            return status === 200;
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                console.error(error);
            } else {
                console.error(error);
            }
            this._emailError('_putJsonData', url, JSON.stringify(error));
        }
        return false;
    };

    private static _sendJsonDataWithResponse = async (method: 'POST' | 'PUT', url: string, inputData: any): Promise<any | null> => {
        if (this.isTesting) {
            const urlObject = new URL(url);
            var suffix = '';
            if (urlObject.search) {
                // suffix = '-' + CryptoJS.SHA256(urlObject.search).toString(CryptoJS.enc.Hex);
                suffix = '/' + urlObject.search.replaceAll('?', '').replaceAll('=', '-').replaceAll('&', '/');
            }
            console.log('SUFIX:', suffix);
            const data = await this._fetchJsonData(`${this.testBackendURL}/${method}/${urlObject.pathname.replace(/^\/+|\/+$/g, '')}${suffix}.json`, false);
            if (data === null) {
                return inputData;
            }
            return data;
        }

        const settings = {
            method: method,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${API_KEY}`
            }
        };
        try {
            const { data, status } = await (method === 'PUT' ? axios.put(url, inputData, settings) : axios.post(url, inputData, settings));
            if (status < 200 || status >= 300) {
                this._emailError(`_${method.toLocaleLowerCase()}FormData`, url, JSON.stringify({
                    input: inputData,
                    response: data
                }));
            } else {
                return data;
            }
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                console.error(error);
            } else {
                console.error(error);
            }
            this._emailError(`_${method.toLocaleLowerCase()}JsonDataWithResponse`, url, JSON.stringify(error));
        }
        return null;
    };

    private static _deleteJsonData = async (url: string): Promise<boolean> => {
        if (this.isTesting) {
            throw new Error('_deleteJsonData not implemented!!!');
        }

        const settings = {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${API_KEY}`
            }
        };
        try {
            const { status } = await axios.put(url, {}, settings);
            return status === 200;
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                console.error(error);
            } else {
                console.error(error);
            }
            this._emailError('_deleteJsonData', url, JSON.stringify(error));
        }
        return false;
    };

    static async lastTransaction(): Promise<Date> {
        const jsonData = await this._fetchJsonData(`${API_URL}/bank_transactions/get_last_bank_transaction_date`);
        console.log('lastTransaction:', jsonData);
        if (jsonData && jsonData.last_extracted_date) {
            return new Date(jsonData.last_extracted_date);
        }
        return new Date();
    }

    static async bankTransactions(iban: string | null, card: string | null, page: number, pageSize = GlobalConstants.pageSize, sortOrder='desc', sortBy='extracted_date', extraFilters = ''): Promise<IBankTransactionsResponseData> {
        var customFilters = '';
        if (iban) {
            customFilters = `sender_iban=${iban}&`;
        }
        if (card) {
            customFilters = `extracted_card_name=${card}&${customFilters}`;
        }
        if (extraFilters && extraFilters !== '') {
            customFilters = `${extraFilters}&${customFilters}`;
        }
        const jsonData = await this._fetchJsonData(`${API_URL}/bank_transactions/?${customFilters}page=${page}&per_page=${pageSize}&sort_by=${sortBy}&sort_order=${sortOrder}`);
        if (jsonData) {
            return jsonData;
        }
        return emptyResponseData;
    }

    static async bankTransactionsMatched(iban: string, card: string, page: number, pageSize = GlobalConstants.pageSize, sortOrder='desc', sortBy='extracted_date'): Promise<IBankTransactionsResponseData> {
        return await ApiCalls.bankTransactions(iban, card, page, pageSize, sortOrder, sortBy, 'matched=true');
    }

    static async bankTransactionsUnmatched(iban: string, card: string | null, page: number, pageSize = GlobalConstants.pageSize, sortOrder='desc', sortBy='extracted_date'): Promise<IBankTransactionsResponseData> {
        return await ApiCalls.bankTransactions(iban, card, page, pageSize, sortOrder, sortBy, 'matched=false&extracted_type=POS&extracted_type=ECOM&refund_reference_id=None');
    }

    static async boatCash(userID: number, currency: string, page: number, pageSize = GlobalConstants.pageSize, sortOrder='desc'): Promise<IPettyCashResponseData> {
        var customFilters = '';
        if (userID) {
            customFilters = `user_id=${userID}&`;
        }
        if (currency) {
            customFilters = `currency=${currency}&${customFilters}`;
        }
        const jsonData = await this._fetchJsonData(`${API_URL}/receipts/get_petty_cash_receipts_and_bank_data?${customFilters}page=${page}&per_page=${pageSize}&sort_order=${sortOrder}`);
        if (jsonData) {
            return jsonData;
        }

        return emptyPettyCashResponseData;
    }

    static async userBoatCash(userID: number): Promise<IUsersPettyCashResponseData[]> {
        const jsonData = await this._fetchJsonData(`${API_URL}/receipts/get_petty_cash?user_id=${userID}`);
        if (jsonData) {
            return jsonData;
        }
        return [];
    }

    static async crew(yachtId: number, page=1, pageSize=100): Promise<ICrewResponseData> {
        const jsonData = await this._fetchJsonData(`${API_URL}/users/?page=${page}&per_page=${pageSize}&sort_by=created_at&sort_order=desc&person_group=Crew&yacht_id=${yachtId}`);
        if (jsonData) {
            return jsonData;
        }
        return emptyResponseData;
    }

    static async employees(ymcId: number, page=1, pageSize=100): Promise<ICrewResponseData> {
        const jsonData = await this._fetchJsonData(`${API_URL}/users/?page=${page}&per_page=${pageSize}&sort_by=created_at&sort_order=desc&person_group=Employee`);
        if (jsonData) {
            return jsonData;
        }
        return emptyResponseData;
    }

    static async coOwners(yachtId: number): Promise<ICrewResponseData> {
        const jsonData = await this._fetchJsonData(`${API_URL}/users/?page=1&per_page=20&sort_by=created_at&sort_order=desc&person_group=Owner&yacht_id=${yachtId}`);
        if (jsonData) {
            return jsonData;
        }
        return emptyResponseData;
    }

    static async cards(yachtId: number): Promise<ICrewData[]> {
        const jsonData = await this._fetchJsonData(`${API_URL}/users/?page=1&per_page=100&sort_by=card_name&sort_order=asc&card_name_not=None&yacht_id=${yachtId}`);
        if (jsonData) {
            return (jsonData as ICrewResponseData).items;
        }
        return [];
    }

    static async fleet(page = 1, pageSize=10): Promise<IYachtResponseData> {
        let filter = '';
        if ([GlobalConstants.UserRole.ADMIN, GlobalConstants.UserRole.STANDARD].includes(ReduxUpdater.authenticatedUser?.user_role ?? '')) {
            const jsonData = await this._fetchJsonData(`${API_URL}/yachts/${ReduxUpdater.authenticatedUser?.yacht_id}`);
            if (jsonData) {
                return {
                    items: [jsonData as IYachtData],
                    total: 1,
                    page: 1,
                    pages: 1,
                    per_page: 1,
                    has_next: false,
                    has_prev: false,
                } as IYachtResponseData;
            }
            return emptyResponseData;
        }
        const jsonData = await this._fetchJsonData(`${API_URL}/yachts/?page=${page}&per_page=${pageSize}&sort_by=name&sort_order=asc${filter}`);
        if (jsonData) {
            return jsonData;
        }
        return emptyResponseData;
    }

    static async yacht(yachtId: number): Promise<IYachtData | null> {
        const jsonData = await this._fetchJsonData(`${API_URL}/yachts/${yachtId}`);
        if (jsonData) {
            return jsonData;
        }
        return null;
    }

    static async yachtCurrencies(yachtId: number): Promise<IYachtCurrenciesData | null> {
        const jsonData = await this._fetchJsonData(`${API_URL}/receipts/yacht/${yachtId}/currencies`);
        if (jsonData) {
            return jsonData;
        }
        return null;
    }

    static async currencies(): Promise<ICurrencyData[]> {
        const jsonData = await this._fetchJsonData(`${API_URL}/currencies/?active=true`);
        if (jsonData) {
            return jsonData.items;
        }
        return [];
    }

    static async receipts(user: number[] | null, page: number, pageSize = GlobalConstants.pageSize, sortOrder='desc', sortBy='booking_date', extraFilters = ''): Promise<IReceiptsResponseData> {
        var customFilters = '';
        if (user !== null && user.length > 0) {
            customFilters = user.map(n => `user_id=${n}`).join('&') + '&';
        }
        console.log('receipts.CustomFILTERS:', customFilters);
        if (extraFilters && extraFilters !== '') {
            customFilters = `${extraFilters}&${customFilters}`;
        }
        console.log('receipts.CustomFILTERS2:', customFilters);
        const jsonData = await this._fetchJsonData(`${API_URL}/receipts/?${customFilters}page=${page}&per_page=${pageSize}&sort_by=${sortBy}&sort_order=${sortOrder}`);
        if (jsonData) {
            return jsonData;
        }
        return emptyResponseData;
    }

    static async receiptHistory(receiptId: number, page=1, pageSize=10, sortOrder='asc', sortBy='id'): Promise<IReceiptsHistoryResponseData> {
        const jsonData = await this._fetchJsonData(`${API_URL}/receipts/history/?receipt_id=${receiptId}&page=${page}&per_page=${pageSize}&sort_by=${sortBy}&sort_order=${sortOrder}`);
        if (jsonData) {
            return jsonData;
        }
        return emptyResponseData;
    }

    static async reimbursements(user: number[] | null, page: number, pageSize = GlobalConstants.pageSize, sortOrder='desc', sortBy='booking_date', extraFilters = ''): Promise<IReceiptsResponseData> {
        var customFilters = '';
        if (user !== null && user.length > 0) {
            customFilters = user.map(n => `user_id=${n}`).join('&') + '&';
        }
        console.log('receipts.CustomFILTERS:', customFilters);
        if (extraFilters && extraFilters !== '') {
            customFilters = `${extraFilters}&${customFilters}`;
        }
        console.log('receipts.CustomFILTERS2:', customFilters);
        const jsonData = await this._fetchJsonData(`${API_URL}/receipts/?${customFilters}receipt_type=reimbursement&receipt_status=confirmed&reimbursement_package_id=null&page=${page}&per_page=${pageSize}&sort_by=${sortBy}&sort_order=${sortOrder}`);
        if (jsonData) {
            return jsonData;
        }
        return emptyResponseData;
    }

    static async reimbursementReports(user: number[] | null, page: number, pageSize = GlobalConstants.pageSize, sortOrder='desc', sortBy='booking_date', extraFilters = ''): Promise<IReimbursementPackagesResponseData> {
        var customFilters = '';
        if (user !== null && user.length > 0) {
            customFilters = user.map(n => `user_id=${n}`).join('&') + '&';
        }
        console.log('reimbursementReports.CustomFILTERS:', customFilters);
        if (extraFilters && extraFilters !== '') {
            customFilters = `${extraFilters}&${customFilters}`;
        }
        console.log('reimbursementReports.CustomFILTERS2:', customFilters);
        const jsonData = await this._fetchJsonData(`${API_URL}/reimbursement_packages/?${customFilters}page=${page}&per_page=${pageSize}&sort_by=${sortBy}&sort_order=${sortOrder}`);
        if (jsonData) {
            return jsonData;
        }
        return emptyResponseData;
    }

    static async reimbursementUsersSummary(yachtId: number): Promise<IReimbursementUsersSummaryResponseData> {
        const jsonData = await this._fetchJsonData(`${API_URL}/reimbursement_packages/yacht/${yachtId}/users-summary`);
        if (jsonData) {
            return jsonData;
        }
        return {} as IReimbursementUsersSummaryResponseData;
    }
 
    static async reviewAndConfirmReceipts(user: number[], page: number, pageSize = GlobalConstants.pageSize, sortOrder='asc', sortBy='booking_date'): Promise<IReceiptsResponseData> {
        return await this.receipts(user, page, pageSize, sortOrder, sortBy, `receipt_status_not=confirmed&receipt_status_not=trashed&receipt_status_not=locked`);
    }

    static async confirmedReceipts(user: number[], page: number, pageSize = GlobalConstants.pageSize, sortOrder='desc', sortBy='booking_date', extraFilters=''): Promise<IReceiptsResponseData> {
        // Removed: &receipt_status_not=trashed&receipt_status_not=locked
        return await this.receipts(user, page, pageSize, sortOrder, sortBy, `receipt_status=confirmed&receipt_type=None&receipt_type=petty_cash${extraFilters}`);
    }

    static async getSignedUrl(imagePath: string, expiresSec = 604800) {
        if (!imagePath) {
            return GlobalConstants.receiptPlaceholder;
        }

        const data = localStorage.getItem(`${this._LOCAL_STORAGE_IMAGES}::${imagePath}`);
        if (data !== null) {
            const D = JSON.parse(data);
            if (Date.now() < D.ts) {
                console.log('getSignedUrl:', D.signedUrl);
                return D.signedUrl;
            }
        }

        const parts = imagePath.split('/');
        const fileName = parts.pop();
        const path = parts.join('/');
        await GlobalConstants.supabase
            .storage.from(path)
            .list(`${path}/`, { limit: 100 });

        const options = {
            // transform: {
            //     height: 600,
            //     width: 600,
            // }
        };

        const result = await GlobalConstants.supabase.storage.from(path).createSignedUrl(fileName ?? '?', expiresSec, options);
        const signedUrl = result.data ? result.data.signedUrl : GlobalConstants.receiptPlaceholder;
        localStorage.setItem(`${this._LOCAL_STORAGE_IMAGES}::${imagePath}`, JSON.stringify({
            signedUrl: signedUrl,
            ts: Date.now() + expiresSec * 1000
        }));
        console.log('getSignedUrl:', signedUrl);
        return signedUrl;
    }

    static async accountingCategories(): Promise<IAccountingCategoriesData[]> {
        const jsonData = await this._fetchJsonData(`${API_URL}/categories/`);
        if (jsonData) {
            return (jsonData as IAccountingCategories).items;
        }
        return [];
    }

    static async generatePreliminaryReimbursementReport(userId: number): Promise<any | null> {
        const jsonData = await this._postJsonData(
            `${API_URL}/reimbursement_packages/report/preliminary`,
            {
                user_id: userId
            },
            {
                responseType: 'blob'
            },
        );
        if (jsonData.status === 200) {
            return jsonData.data as IGenerateReportData;
        }
        return null;
    }

    static async generateReimbursementReport(userId: number): Promise<any | null> {
        const jsonData = await this._postJsonData(
            `${API_URL}/reimbursement_packages/report`,
            {
                user_id: userId
            },
            {
                responseType: 'blob'
            },
        );
        if (jsonData.status === 200) {
            return jsonData.data as IGenerateReportData;
        }
        return null;
    }

    static async regenerateReimbursementReport(packageId: number): Promise<any | null> {
        const jsonData = await this._postJsonData(
            `${API_URL}/reimbursement_packages/report/regenerate`,
            {
                package_id: packageId
            },
            {
                responseType: 'blob'
            },
        );
        if (jsonData.status === 200) {
            return jsonData.data as IGenerateReportData;
        }
        return null;
    }

    static async zohoAuthCheck(yacht_id: number): Promise<boolean> {
        const status = await this._fetchStatus(`${API_URL}/zoho/${yacht_id}/auth-check`);
        return status === 200;
    }

    static async sendToZoho(yacht_id: number, previous_months_only = false, limit_preceding_receipts_to_last_month_start = false): Promise<ISendToZohoResponse | null> {
        const URI = `${API_URL}/receipts/yacht/${yacht_id}/send-to-zoho?changed_by_user_id=${ReduxUpdater.authenticatedUser?.id}&previous_months_only=${previous_months_only ? 'true' : 'false'}&limit_preceding_receipts_to_last_month_start=${limit_preceding_receipts_to_last_month_start ? 'true' : 'false'}`;
        const response = await this._postJsonData(URI, '');
        if (response.status === 200) {
            if (response.data.failed > 0) {
                this._emailError('sendToZoho', URI, JSON.stringify(response.data));
            }
            return response.data;
        }
        return null;
    }

    static async unmatchReceipt(receiptId: number): Promise<ISendToZohoResponse | null> {
        const response = await this._postJsonData(`${API_URL}/receipts/${receiptId}/unmatch_receipt?changed_by_user_id=${ReduxUpdater.authenticatedUser?.id}`, '');
        if (response.status === 200) {
            if (response.data.failed > 0) {
                this._emailError('unmatchReceipt', `${API_URL}/receipts/${receiptId}/unmatch_receipt?changed_by_user_id=${ReduxUpdater.authenticatedUser?.id}`, JSON.stringify(response.data));
            }
            return response.data;
        }
        return null;
    }

    static async syncChartOfAccounts(): Promise<boolean> {
        const response = await this._postJsonData(`${API_URL}/zoho/sync-chart-of-accounts`, '');
        if (response.status === 200) {
            return true;
        }
        return false;
    }

    static async createReceipt(receipt: IReceiptData): Promise<any | null> {
        return await this._sendJsonDataWithResponse('POST', `${API_URL}/receipts/`, {
            ...receipt,
            changed_by_user_id: ReduxUpdater.authenticatedUser?.id,
        });
    }

    static async updateReceipt(receipt: IReceiptData): Promise<any | null> {
        return await this._sendJsonDataWithResponse('PUT', `${API_URL}/receipts/${receipt.id}`, {
            ...receipt,
            changed_by_user_id: ReduxUpdater.authenticatedUser?.id,
        });
    }

    static async incYachtReceiptCounter(yacht: IYachtData): Promise<any | null> {
        return await this._sendJsonDataWithResponse('PUT', `${API_URL}/yachts/gsheet_id/${yacht.gsheet_id}`, yacht);
    }

    static dataURIToBlob(dataURI: string) {
        // Split the dataURI into the mime type part and the data part
        const splitDataURI = dataURI.split(',');
        const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
        const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

        // Write the bytes of the string to an array buffer
        const ia = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], { type: mimeString });
    }

    static async uploadFileToSupabase(base64ImageString: string, fileName: string): Promise<IUploadFileToSupabaseResponse | null> {
         if (!base64ImageString) {
            toast.error('No file provided');
            return null;
        }

        try {
            const blob = this.dataURIToBlob(base64ImageString);
            const formData = new FormData();
            formData.append('file', blob, fileName);

            // Send the file to your pre-defined endpoint
            const response = await this._postFormData(`${API_URL}/receipts/upload_file_to_supabase`, formData);

            if (!response) {
                console.error("_postFormData error:", response);
            }

            return response as IUploadFileToSupabaseResponse;
        } catch (error) {
            console.error("[v0] uploadFileToSupabase error:", error)
            return null;
        }
    }

    static async getBinaryFromFile(file: File) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.addEventListener('load', () => resolve(reader.result));
            reader.addEventListener('error', (err) => reject(err));
            reader.readAsArrayBuffer(file);
        });
    }

    static async uploadReceipt(userId: number, file: File, receiptType: string, description: string): Promise<IUploadReceiptResponse | null> {
        try {
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);

            const formData = new FormData();
            formData.append("user_id", userId.toString());
            formData.append("file", file);
            if (receiptType !== '') {
                formData.append("receipt_type", receiptType);
            }
            formData.append("description", description);
            const response = await this._postFormData(`${API_URL}/receipts/upload_receipt`, formData);

            if (!response) {
                console.error("_postJsonData error:", response);
            }

            return response as IUploadReceiptResponse;
        } catch (error) {
            console.error("[v0] uploadReceipt error:", error)
            return null;
        }
    }

    // static async deleteReceipt(receipt: IReceiptData): Promise<boolean> {
    //     return await this._deleteJsonData(`${API_URL}/receipts/${receipt.id}`);
    // }

    static async UPLOAD(formData: FormData): Promise<boolean>{
        try {
            const file = formData.get("file") as File;

            if (!file) {
                toast.error('No file provided');
                return false;
            }

            // Send the file to your pre-defined endpoint
            const response = await this._postFormData(`${API_URL}/bank_transactions/upload_bank_transactions`, formData);

            if (!response) {
                console.error("_postFormData error");
            }

            return response;
        } catch (error) {
            console.error("[v0] Upload error:", error)
            return false;
        }
    }

    static async getUser(emailOrPhone: string): Promise<ICrewData | null> {
        if (emailOrPhone.includes('@')) {
            const jsonData = await this._fetchJsonData(`${API_URL}/users/?email=${encodeURIComponent(emailOrPhone)}`);
            console.log('getUserByEmail', jsonData);
            if (jsonData) {
                return (jsonData as ICrewResponseData).items[0];
            }
        } else {
            var phoneNumber = emailOrPhone;
            if (phoneNumber.startsWith('+')) {
                phoneNumber = phoneNumber.slice(1);
            }
            if (phoneNumber.startsWith('00')) {
                phoneNumber = phoneNumber.slice(2);
            }
            const jsonData = await this._fetchJsonData(`${API_URL}/users/?phone_number=${emailOrPhone}`);
            console.log('getUserByPhone', jsonData);
            if (jsonData) {
                return (jsonData as ICrewResponseData).items[0];
            }
        }
        return null;
    }
}
